// Object identity links observations of the same thrown failure. Never infer a
// shared incident from matching text, a session ID, or a nearby timestamp.
import { createRandomId } from './randomId.js';
const occurrences = new WeakMap();
export function getErrorOccurrenceId(error) {
    if (!error || typeof error !== 'object')
        return undefined;
    const chain = [];
    let current = error;
    let id;
    while (current && typeof current === 'object' && chain.length < 8 && !chain.includes(current)) {
        chain.push(current);
        id = occurrences.get(current);
        if (id)
            break;
        try {
            current = Object.getOwnPropertyDescriptor(current, 'cause')?.value;
        }
        catch {
            break;
        }
    }
    id ?? (id = createRandomId());
    for (const item of chain)
        occurrences.set(item, id);
    return id;
}
